import { TileLayer, type TileLayerProps } from 'react-leaflet';
import {
  OSM_RASTER_TILE_URL,
  OSM_TILE_ATTRIBUTION,
  retryFailedLeafletTile,
} from '@/utils/mapTiles';

type OsmTileLayerProps = Omit<TileLayerProps, 'url'> & {
  url?: string;
};

export function OsmTileLayer({
  attribution = OSM_TILE_ATTRIBUTION,
  url = OSM_RASTER_TILE_URL,
  maxZoom = 19,
  keepBuffer = 2,
  updateWhenZooming = false,
  eventHandlers,
  ...rest
}: OsmTileLayerProps) {
  return (
    <TileLayer
      {...rest}
      url={url}
      attribution={attribution}
      maxZoom={maxZoom}
      keepBuffer={keepBuffer}
      updateWhenZooming={updateWhenZooming}
      eventHandlers={{
        ...eventHandlers,
        tileerror: (event) => {
          eventHandlers?.tileerror?.(event);
          retryFailedLeafletTile(event.tile);
        },
      }}
    />
  );
}
